import DynamicPage from 'components/DynamicPage';

const TnC = () => {
  return(
    <DynamicPage url="/tnc" />
  )
}

export default TnC;
